import React from 'react';
import './Internship.css';

const Internship = () => {
  const formUrl = 'https://forms.gle/VM4H1PfESFCRaaS48';

  const tracks = [
    {
      title: 'Web Development',
      description: 'Build modern, responsive web applications using popular frameworks.'
    },
    {
      title: 'App Development',
      description: 'Create native and cross-platform mobile applications.'
    },
    {
      title: 'Machine Learning',
      description: 'Apply ML algorithms to solve real-world problems.'
    },
    {
      title: 'Data Science',
      description: 'Turn data into insights through statistics and modeling.'
    },
    {
      title: 'Data Analytics',
      description: 'Analyze datasets to drive business decisions and strategy.'
    },
    {
      title: 'Internet of Things (IoT)',
      description: 'Connect devices and automate with smart, embedded systems.'
    },
    {
      title: 'Cloud Computing',
      description: 'Design, deploy, and manage scalable cloud infrastructure.'
    },{
      title: 'Robotics & Automation',
      description: 'Design intelligent robotic systems and automate processes using embedded technologies.'
    }
  ];

  return (
    <section id="internship" className="internship">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Internship</h2>
          <p className="section-subtitle">Choose Your Track</p>
        </div>
        <div className="internship-content">
          <div className="internship-intro">
            <h3>Join Our Internship</h3>
            <p>
              At Veltroz, our internships focus on hands-on learning with real projects and
              guidance from experienced mentors. Pick a track and apply below.
            </p>
          </div>
          <div className="internship-details">
            <div className="tracks-section">
              <h3>Available Tracks</h3>
              <div className="tracks-grid">
                {tracks.map((track, index) => (
                  <div key={index} className="track-card">
                    <h4>{track.title}</h4>
                    <p>{track.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="internship-cta">
            <p>Ready to start your journey with us?</p>
            <a 
              className="btn btn-primary"
              href={formUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Apply Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Internship;

